
export default {
  name: 'EventCardLectors',
  props: {
    lectors: {
      type: Array,
      default: () => [],
      required: true
    },

    maxAvatars: {
      type: Number,
      default: 3,
      required: false
    },

    container: {
      type: String,
      default: 'default',
      validator: value => ['widget', 'default'].includes(value)
    },

    time: {
      type: String,
      required: true
    }
  },

  computed: {
    lectorsCount() {
      return this.lectors.length
    },

    isOneLector() {
      return this.lectors.length < 2
    },

    lectorsAvatars() {
      return this.lectors.map(lector => ({
        src: Array.isArray(lector.avatar)
          ? lector.avatar[0].url
          : lector.avatar,
        userName: `${lector.firstname} ${lector.lastname}`
      }))
    },

    lectorsNames() {
      return this.lectors.map(
        lector => `${lector.firstname} ${lector.lastname}`
      )
    }
  }
}
